var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { CompanyStarCycle, PrivateStarCycle, } from '@debbie/common/dist/customers';
import { getRKIRegistrations } from '@debbie/common/dist/customers/helpers';
import { isCaseworker } from '@debbie/common/dist/permissions';
import { c, h } from '@debbie/cortex/dist';
import * as customersAPI from '@debbie/cortex/dist/api/customers';
import { useCustomerRelatedCases } from '@debbie/cortex/dist/customers-related-cases';
import { selectRole } from '@debbie/cortex/dist/me/selectors';
import THEME from '../../theme';
import CasesOnCustomer from '../Customers/CasesOnCustomer';
import { Row } from '../Grid';
import { Check, Crosshair, X } from '../Icons';
import Loading from '../Loading';
import Panel from '../Panel';
import Tooltip from '../Tooltip';
import CasesRelatedToCustomer from './CasesRelatedToCustomer';
import UserInfo from './UserInfo';
const UserOnCustomer = (props) => {
    const { user, customer } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const meRole = useSelector(selectRole);
    const relatedCasesLoadable = useCustomerRelatedCases(props.customer.customerId);
    const relatedCases = h.hasData(relatedCasesLoadable)
        ? relatedCasesLoadable.data
        : null;
    const [loadingIsContact, setLoadingIsContact] = useState(false);
    const [deletingUser, setDeletingUser] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [showTooltipOnTop, setShowTooltipOnTop] = useState(false);
    const ref = useRef(null);
    const onMouseIn = () => setHovered(true);
    const onMouseOut = () => setHovered(false);
    const { name, companyStatus, movedAbroad, companies, aksError, status, addressProtection, dissolvedStatuses, guardian, } = user.details;
    const rkiRegistrations = getRKIRegistrations(user.details);
    const casesOnCustomerCount = customer.cases.length + (relatedCases ? relatedCases.length : 0);
    const isMeCaseWorker = meRole && isCaseworker(meRole);
    const canCheckUser = (user.contact &&
        customer.users.filter((_user) => _user.contact).length > 1) ||
        !user.contact;
    return (React.createElement(UserPreviewStyled, { onMouseEnter: onMouseIn, onMouseLeave: onMouseOut, onClick: () => {
            if (props.onClick)
                props.onClick(user);
        }, selected: props.selected, subscribedToCosmo: user.subscribedToCosmo, ref: ref, open: hovered, showTooltipOnTop: showTooltipOnTop },
        React.createElement(ContactCheckmark, null,
            React.createElement("div", { className: `checkmark ${user.contact && 'checked'} ${isMeCaseWorker ? '' : 'not-editable'}`, style: { cursor: canCheckUser ? 'pointer' : 'default' }, onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    e.preventDefault();
                    e.stopPropagation();
                    if (site === Site.Caseworker && canCheckUser) {
                        setLoadingIsContact(true);
                        try {
                            yield customersAPI.patchUser(customer.customerId, user.userId, {
                                contact: !user.contact,
                            });
                            yield c.customers.getById(customer.customerId);
                        }
                        catch (error) {
                            alert('Error');
                        }
                        setLoadingIsContact(false);
                    }
                }) }, loadingIsContact ? (React.createElement(Loading, { width: "10px", style: { margin: '2px 2px 3px 1px' } })) : user.contact ? (React.createElement(Check, null)) : (React.createElement(Crosshair, null)))),
        isMeCaseWorker && (React.createElement(DeleteUser, { className: "delete-user", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                e.preventDefault();
                e.stopPropagation();
                if (confirm('Er du sikker på at du vil slette denne bruger fra kunden?')) {
                    setDeletingUser(true);
                    try {
                        yield customersAPI.deleteUser(customer.customerId, user.userId);
                        yield c.customers.getById(customer.customerId);
                    }
                    catch (error) {
                        alert('Error');
                    }
                    setDeletingUser(false);
                }
            }) }, deletingUser ? (React.createElement(Loading, { width: "10px", style: { margin: '2px 2px 3px 1px' } })) : (React.createElement(X, null)))),
        React.createElement("div", { className: "debtor-name" },
            React.createElement(Badges, null,
                rkiRegistrations && !!rkiRegistrations.length && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.rkiRegistrations },
                    "RKI (",
                    rkiRegistrations.length,
                    ")")),
                !!casesOnCustomerCount && !!(casesOnCustomerCount > 1) && (React.createElement(WarningBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.otherCasesOnDebtorTooltip, onClick: (e) => {
                        if (site === Site.Caseworker) {
                            e.stopPropagation();
                            e.preventDefault();
                            c.redirect.redirect(`/creditors/${customer.creditorId}/customers/${customer.customerId}/cases`);
                        }
                    } }, casesOnCustomerCount === 2
                    ? lang.debtors.otherCasesOnDebtor
                    : `${casesOnCustomerCount} ${lang.debtors.otherCasesOnDebtorPlural}`)),
                companyStatus &&
                    !status &&
                    !['aktiv', 'normal'].includes(companyStatus.toLowerCase()) && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.companyStatus }, companyStatus)),
                customer.isCompany &&
                    (status === null || status === void 0 ? void 0 : status.stage) &&
                    status.stage !== CompanyStarCycle.Active && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.companyStatus }, lang.debtors.status[status.stage])),
                movedAbroad &&
                    movedAbroad[0] &&
                    (status === null || status === void 0 ? void 0 : status.stage) === PrivateStarCycle.GoneAway && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `${lang.debtors.movedTo} ${movedAbroad.join(', ')}` }, lang.debtors.movedAbroad)),
                (guardian === null || guardian === void 0 ? void 0 : guardian.status) && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.guardian }, lang.debtors.guardian)),
                dissolvedStatuses && dissolvedStatuses.status && (React.createElement(BadgeStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `${lang.debtors.dissolutionStatus} ${': '} ${
                    // @ts-ignore
                    lang.debtors.dissolvedStatus[dissolvedStatuses.status]}` }, 
                // @ts-ignore
                lang.debtors.dissolvedStatus[dissolvedStatuses.status])),
                companies && companies[0] && (React.createElement(WarningBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": `Owns ${companies
                        .map((company) => company.name)
                        .join(', ')}` }, companies.length > 1
                    ? lang.debtors.ownsCompanies
                    : lang.debtors.ownsCompany)),
                aksError ? (aksError === 'Personen kunne identificeres, men er død' ? (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.cprStatus }, lang.debtors.status[PrivateStarCycle.Dead])) : (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.aksFailed }, "AKS!"))) : null,
                !customer.isCompany &&
                    status &&
                    !movedAbroad &&
                    status.stage !== 'ACTIVE' &&
                    lang.debtors.status[status.stage] && (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.cprStatus }, lang.debtors.status[status.stage])),
                addressProtection && (React.createElement(DangerousBadge, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.debtors.addressProtection }, lang.debtors.addressProtectionShort))),
            React.createElement("div", { className: "debtor-icon" }, (name || '-').slice(0, 1)),
            React.createElement("div", { style: {
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                    marginBottom: '2px',
                } },
                React.createElement("div", { style: {
                        fontSize: '.7em',
                        fontWeight: 900,
                    } },
                    lang.roles[user.relation],
                    user.details.type &&
                        ` - ${lang.alternativeContactTypes[user.details.type]}`,
                    user.details.description && (React.createElement("span", { style: { color: THEME.COLOR_ACCENT } },
                        ' ',
                        "- ",
                        user.details.description))),
                React.createElement("div", null,
                    React.createElement("span", null, name),
                    React.createElement("span", { className: "debtor-id" },
                        "@",
                        user.id)))),
        hovered && !props.noPreview && (React.createElement(Tooltip, { tooltipToLeft: props.tooltipToLeft, parentRef: ref, setShowTooltipOnTop: setShowTooltipOnTop, shouldShowOnTop: showTooltipOnTop },
            React.createElement(Row, null,
                React.createElement(Panel, null,
                    React.createElement(UserInfo, { customer: customer, user: user })),
                React.createElement(Panel, { header: lang.customers.casesOnCustomer },
                    React.createElement(CasesOnCustomer, { customer: customer })),
                React.createElement(Panel, { header: lang.customers.relatedCases },
                    React.createElement("p", null, lang.customers.casesRelatedToCustomerDescription),
                    React.createElement(CasesRelatedToCustomer, { customerId: customer.customerId })))))));
};
export default UserOnCustomer;
const Badges = styled.div `
  position: absolute;
  top: -6px;
  right: 15px;
  color: ${THEME.COLOR_SECONDARY};
  font-size: 0.7em;
  font-weight: bold;
`;
const UserPreviewStyled = styled.div `
  position: relative;
  padding: 6px 12px 6px 6px;
  background-color: #e6e6e6;
  margin-top: 10px;
  border-radius: 3px;
  cursor: pointer;

  ${(props) => props.open
    ? props.showTooltipOnTop
        ? `
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      `
        : `
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      `
    : ''}

  div.debtor-icon {
    display: inline-block;
    flex-basis: 30px;
    flex-grow: 0;
    flex-shrink: 0;
    border-radius: 4px;
    background-color: ${(props) => props.subscribedToCosmo ? THEME.COLOR_ACCENT : THEME.COLOR_GREY};
    margin-right: 7px;
    color: ${THEME.COLOR_SECONDARY};
    padding: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div.debtor-name {
    font-weight: bold;
    font-size: 0.8em;
    font-weight: initial;
    display: flex;
  }

  span.debtor-id {
    margin-left: 4px;
    font-weight: bold;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  &:hover .delete-user {
    opacity: 1;
  }

  &::before {
    content: ' ';
    position: absolute;
    height: calc(100% + 6px);
    width: calc(100% + 6px);
    left: -3px;
    top: -3px;
    border-radius: 5px;
    ${(props) => props.selected ? `border: 2px solid ${THEME.COLOR_ACCENT};` : ''}
  }

  ${(props) => props.selected
    ? `
      &::after {
        content: '\\25ba';
        position: absolute;
        font-size: 0.7em;
        color: #7568f6;
        right: -10px;
        top: calc(50% - 7px);
        }
      `
    : ''}
`;
const badgeCss = `
  border-radius: 8px;
  background-color: ${THEME.DANGEROUS};
  padding: 0.2em 0.5em;
  float: right;
  margin-left: 5px;
  `;
const BadgeStyled = styled.div `
  ${badgeCss}
`;
const WarningBadge = styled.div `
  ${badgeCss}
  background-color: ${THEME.WARNING};
`;
const DangerousBadge = styled.div `
  ${badgeCss}
  background-color: ${THEME.DANGEROUS};
`;
const ContactCheckmark = styled.div `
  position: relative;
  .checkmark {
    background-color: lightgrey;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    position: absolute;
    top: -12px;
    left: -11px;
    color: ${THEME.COLOR_SECONDARY};
    text-align: center;
    cursor: pointer;
    svg {
      height: 10px;
      width: 10px;
      margin: -3px 0px 3px;
    }
    &.not-editable {
      cursor: default;
    }
    &.checked {
      background-color: ${THEME.SUCCESS};
    }
  }
`;
const DeleteUser = styled.div `
  background-color: lightgrey;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  position: absolute;
  top: -6px;
  right: -4px;
  color: ${THEME.COLOR_GREY};
  text-align: center;
  cursor: pointer;
  opacity: 0;

  svg {
    height: 10px;
    width: 10px;
    margin: -3px 0px 3px;
  }
`;
//# sourceMappingURL=UserOnCustomer.js.map